import { FC } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

export const LineItemsBulkPayablesCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const {
        selectedLineItemCount = 0,
        hasSelectedAllMatchingLineItems = false,
        lineItemsBulkPayablesOptions = [],
    } = options;

    const selectionDescription = hasSelectedAllMatchingLineItems
        ? "all matching line items"
        : pluralizeWithCount("line item", selectedLineItemCount);

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set payables account for ${selectionDescription}`}
            options={lineItemsBulkPayablesOptions}
        />
    );
};
